import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=0c163eef&scoped=true&"
var script = {}
import style0 from "./agreement.scss?vue&type=style&index=0&id=0c163eef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c163eef",
  null
  
)

export default component.exports